import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import pluralize from 'pluralize';

import { getAsset } from '../../../../util/assets';
import Badge from '../../Badge';
import PriceDisplay from '../../PriceDisplay';
import { getIdentityName } from '../../../../util/identity';
import Button from '../../Button';
import useOpenAlert from '../../../../hooks/useOpenAlert';

const propTypes = {
  className: PropTypes.string,
  digitalBundle: PropTypes.shape({
    id: PropTypes.string.isRequired,
    photos_count: PropTypes.number,
  }).isRequired,
  identity: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  cartItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  disabled: PropTypes.bool.isRequired,
  onDigitalBundleToggle: PropTypes.func.isRequired,
};

const DigitalBundleOption = ({
  className,
  digitalBundle,
  identity,
  cartItem,
  disabled,
  onDigitalBundleToggle,
}) => {
  const openAlert = useOpenAlert();
  const classes = classNames({
    [className]: !!className,
    'purchasing-option-item': true,
    'purchasing-option-item-album-folder': true,
    'is-selected': !!cartItem,
  });

  const onAddToCart = () => {
    if (disabled) {
      openAlert({
        type: 'info',
        dismissible: false,
        message: ({ onRequestClose }) => (
          <div className="d-flex flex-column align-items-center p-2">
            <img
              src={getAsset('/icon-package-3d.svg')}
              alt=""
              className="mb-2"
            />
            <h4 className="text-center mb-3">
              This digital bundle can only be purchased after adding a print
              package to your cart.
            </h4>
            <Button onClick={onRequestClose}>OK</Button>
          </div>
        ),
      });
      return;
    }

    onDigitalBundleToggle();
  };

  return (
    <div className={classes}>
      <div className="purchasing-option-item-thumb">
        <img width={75} src={getAsset('/photopass.svg')} alt="" />
      </div>

      <div className="purchasing-option-item-content-wrap">
        <div className="purchasing-option-item-title">
          <div className="text-truncate">
            Digital Photo Bundle:{' '}
            {pluralize('photo', digitalBundle.photos_count, true)}
          </div>
          <div className="purchasing-option-item-info-extra">
            <Badge badgeStyle="yellow" className="text-extra-bold">
              <PriceDisplay
                price={digitalBundle.price.value}
                currency={digitalBundle.price.currency}
              />
            </Badge>
          </div>
        </div>

        <div className="purchasing-option-item-content mb-2">
          <p className="text-sm lh-normal text-dark text-bold">
            Select {pluralize('photo', digitalBundle.photos_count, true)} of{' '}
            {getIdentityName(identity)} to download in hi-res.
          </p>
          {disabled && (
            <span className="purchasing-option-item-info-requires-package">
              Requires the purchase of a print package first.
            </span>
          )}
        </div>
        <div className="purchasing-option-item-actions">
          <Button
            btnStyle={classNames({
              primary: !cartItem,
              info: !!cartItem,
            })}
            className={classNames({
              'purchasing-options-item-btn': true,
              'btn-purchase-options-in-cart': !!cartItem,
            })}
            onClick={() => onAddToCart()}
          >
            {cartItem ? (
              <Fragment>In cart</Fragment>
            ) : (
              <Fragment>Add to cart</Fragment>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

DigitalBundleOption.propTypes = propTypes;

export default DigitalBundleOption;
